module.exports = __webpack_public_path__ + "static/media/logo-mp.13e88aa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/logo-mp.jpg
// module id = 413
// module chunks = 0